/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React,{useEffect,useState} from "react";
import { useLocation } from 'react-router-dom'
import verify from '../images/verify.png'
import firebase from '../config/firebase'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import {connect} from "react-redux";
import clientFirebase from '../config/firebase_client'
import {TiTick} from 'react-icons/ti';
function Edit(props) {
  let [rooms,setRooms]=useState(props.location.state.branch.rooms)
  let [currentUpload,setCurrentUpload]=useState('')
  let [progress,setProgress]=useState('0')
  let [currentUpload2,setCurrentUpload2]=useState('')
  let [progress2,setProgress2]=useState('0')
  let [currentUpload3,setCurrentUpload3]=useState('')
  let [progress3,setProgress3]=useState('0')
  let [currentUpload4,setCurrentUpload4]=useState('')
  let [progress4,setProgress4]=useState('0')
  let [currentUpload5,setCurrentUpload5]=useState('')
  let [progress5,setProgress5]=useState('0')
  let [currentUpload6,setCurrentUpload6]=useState('')
  let [progress6,setProgress6]=useState('0')



  let [name,setName]=useState(props.location.state.branch.hotelName)
  let [nameValidation,setNameValidation]=useState('')
  
  let [email,setEmail]=useState(props.location.state.branch.email)
  let [emailValidation,setEmailValidation]=useState('')
  
  let [phone,setPhone]=useState(props.location.state.branch.phone)
  let [phoneValidation,setPhoneValidation]=useState('')
  
  let [Firstname,setFirstName]=useState(props.location.state.branch.name)
  let [FirstnameValidation,FirstsetNameValidation]=useState('')
  
  let [LastName,setLastName]=useState('ee')
  let [LastnameValidation,LastsetNameValidation]=useState('')
  
 
  
  let [price1,setPrice1]=useState(props.location.state.branch.price)
  let [priceValidation,setpriceValidation]=useState('')
  
 
  
  let [address,setAddress]=useState(props.location.state.branch.address)
  let [addressValidation,setAddressValidation]=useState('')
  
  let [country,setCountry]=useState(props.location.state.branch.country)
  let [countryValidation,setCountryValidation]=useState('')
  
  let [zip,setZip]=useState(props.location.state.branch.zipCord)
  let [zipValidation,setzipValidation]=useState('')
  
  let [Details,setDetails]=useState(props.location.state.branch.details)
  let [DetailsValidation,setdetailsValidation]=useState('')
  
  let [city,setCity]=useState(props.location.state.branch.city)
  let [cityValidation,setcityValidation]=useState('')
  
  let [facilities,setFacilities]=useState(props.location.state.branch.facilities)
  let [facilitiesValidation,setfacilitiesValidation]=useState('')
    
  
  let [image1,setimage1]=useState(props.location.state.branch.Images[0].url)
  let [image1Validation,setimage1Validation]=useState('')
  
  let [image2,setimage2]=useState(props.location.state.branch.Images[1].url)
  let [image2Validation,setimage2Validation]=useState('')
  
  let [image3,setimage3]=useState(props.location.state.branch.Images[2].url)
  let [image3Validation,setimage3Validation]=useState('')
  
  let [image4,setimage4]=useState(props.location.state.branch.Images[3].url)
  let [image4Validation,setimage4Validation]=useState('')
  
  let [image5,setimage5]=useState(props.location.state.branch.Images[4].url)
  let [image5Validation,setimage5Validation]=useState('')
  
  
  let [image6,setimage6]=useState(props.location.state.branch.Images[5].url)
  let [image6Validation,setimage6Validation]=useState('')
  let [i1File,seti1File]=useState('')
  let [i2File,seti2File]=useState('')
  let [i3File,seti3File]=useState('')
  let [i4File,seti4File]=useState('')
  let [i5File,seti5File]=useState('')
  let [i6File,seti6File]=useState('')
useEffect(()=>{
  sessionStorage.setItem('p1',false)
  sessionStorage.setItem('p2',false)
  sessionStorage.setItem('p3',false)
  sessionStorage.setItem('p4',false)
  sessionStorage.setItem('p5',false)
  sessionStorage.setItem('p6',false)
  localStorage.setItem('Image1',props.location.state.branch.Images[0].url)
  localStorage.setItem('Image2',props.location.state.branch.Images[1].url)
  localStorage.setItem('Image3',props.location.state.branch.Images[2].url)
  localStorage.setItem('Image4',props.location.state.branch.Images[3].url)
  localStorage.setItem('Image5',props.location.state.branch.Images[4].url)
  localStorage.setItem('Image6',props.location.state.branch.Images[5].url)

  clientFirebase.firestore().collection("All_Hotel").doc(props.location.state.branch.branch_uid)
  .onSnapshot((doc) => {
    if(doc.data()!==undefined){

      setRooms(doc.data().rooms)
    }

  });

},[])
  // clientFirebase.firestore().collection('allHotel')
  // .get().then((doc) => {
  //   if (doc.exists) {
  //       console.log("Document data:", doc.data());
  //   } else {
  //       // doc.data() will be undefined in this case
  //       console.log("No such document!");
  //   }
  // }).catch((error) => {
  //   console.log("Error getting document:", error);
  // });
  
  
  
  
  
  
  
  
    // writeUserData()
    // function writeUserData() {
    //   const db = getDatabase();
    //   set(ref(db, '/'), {
    //     username: 'asdf',
    //     email: 'email',
    //     profile_picture : 'imageUrl'
    //   });
    // }
    function makeid(length) {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
   charactersLength));
     }
     return result;
  }


  
  
    let UpdataBranch=async()=>{
  
   






            setNameValidation('')
            setEmailValidation('')
            setPhoneValidation('')         
            FirstsetNameValidation('')    
            LastsetNameValidation('')
            setcityValidation('')    
            setCountryValidation('')
            setzipValidation('')    
            setdetailsValidation('')    
            setfacilitiesValidation('')
            setimage1Validation('')
            setimage2Validation('')
            setimage3Validation('')
            setimage4Validation('')
            setimage5Validation('')
            setimage6Validation('')
            setpriceValidation('')
            setAddressValidation('')
           
        if(name=='' || email=='' || phone=='' ||Firstname =='' ||LastName =='' ||address=='' ||city=='' ||country=='' ||zip=='' ||Details=='' ||facilities=='' ||image1.length==0 ||image2.length==0 ||  image3.length==0 || image4.length==0 || image5.length==0 || image6.length==0 || price=='' )
              {
  
                if(name==''){
                  setNameValidation('*Required')
                }
                if(email==''){
                  setEmailValidation('*Required')
                }
                if(phone==''){
                  setPhoneValidation('*Required')
                }
                if(Firstname==''){
                  FirstsetNameValidation('*Required')
                }
                if(LastName==''){
                  LastsetNameValidation('*Required')
                }
               
               
                if(price1==''){
                  setpriceValidation('*Required')
                }
                if(city==''){
                  setcityValidation('*Required')
                }
                if(country==''){
                  setCountryValidation('*Required')
                }
                if(zip==''){
                  setzipValidation('*Required')
                }
                if(Details==''){
                  setdetailsValidation('*Required')
                }
                if(facilities==''){
                  setfacilitiesValidation('*Required')
                }
                if(image1==''){
                  setimage1Validation('*Required')
                }
                if(image2==''){
                  setimage2Validation('*Required')
                } 
                if(image3==''){
                  setimage3Validation('*Required')
                } 
                if(image4==''){
                  setimage4Validation('*Required')
                } 
                if(image5==''){
                  setimage5Validation('*Required')
                } 
                if(image6==''){
                  setimage6Validation('*Required')
                }
                if(address==''){
                  setAddressValidation('*Required')
                }
                return
              }

            document.getElementById('loadingSHOW').style.display='block'

             // IMAGE 1
if(image1!==props.location.state.branch.Images[0].url){
  console.log("IM 1>>>>>>>>>>>>");

    //1.
    let pictureRef = clientFirebase.storage().refFromURL(props.location.state.branch.Images[0].url);
   //2.
 pictureRef.delete().catch((e)=>console.log(e))
   //3.
        var ref=clientFirebase.storage().ref(`/`).child(`hotel/${makeid(9)}}`).put(i1File)
        setCurrentUpload('1')
        ref.on('state_changed', function(snapshot){
         // Observe state change events such as progress, pause, and resume
         // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
         var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(Math.floor(progress))
         console.log('IMAGE 1 Upload is ' + progress + '% done');
         if(progress==100){
           
           
        }
      }, function(error) {
        // document.getElementById('loadingSHOW').style.display='none'
        
        // Handle unsuccessful uploads
        console.log(error);
      }, function() {
        ref.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          localStorage.setItem('Image1',downloadURL)
          sessionStorage.setItem('p1',true)
          console.log("I1",downloadURL);
       })
        })

}
else{
  sessionStorage.setItem('p1',true)

}




              // IMAGE 2
if(image2!==props.location.state.branch.Images[1].url){
  console.log("IM 2>>>>>>>>>>>>");

    //1.
    let pictureRef = clientFirebase.storage().refFromURL(props.location.state.branch.Images[1].url);
   //2.
 pictureRef.delete().catch((e)=>console.log(e))
   //3.
        var ref1=clientFirebase.storage().ref(`/`).child(`hotel/${makeid(9)}`).put(i2File)
        setCurrentUpload2('2')
        ref1.on('state_changed', function(snapshot){
         // Observe state change events such as progress, pause, and resume
         // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
         var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress2(Math.floor(progress))
         console.log('IMAGE 2 Upload is ' + progress + '% done');
        
      }, function(error) {
        // document.getElementById('loadingSHOW').style.display='none'
        
        // Handle unsuccessful uploads
        console.log(error);
        }, function() {
          ref1.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            localStorage.setItem('Image2',downloadURL)
            sessionStorage.setItem('p2',true)
            console.log("I2",downloadURL);
          })
        })

}
else{
  sessionStorage.setItem('p2',true)

}




             // IMAGE 3
if(image3!==props.location.state.branch.Images[2].url){
  console.log("IM 3>>>>>>>>>>>>");

    //1.
    let pictureRef = clientFirebase.storage().refFromURL(props.location.state.branch.Images[2].url);
   //2.
 pictureRef.delete().catch((e)=>console.log(e))
   //3.
        var ref2=clientFirebase.storage().ref(`/`).child(`hotel/${makeid(9)}`).put(i3File)
        setCurrentUpload3('3')
        ref2.on('state_changed', function(snapshot){
         // Observe state change events such as progress, pause, and resume
         // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
         var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress3(Math.floor(progress))
         console.log('IMAGE 3 Upload is ' + progress + '% done');
         if(progress==100){
           
        }
        }, function(error) {
          // document.getElementById('loadingSHOW').style.display='none'
          
          // Handle unsuccessful uploads
          console.log(error);
        }, function() {
          ref2.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            localStorage.setItem('Image3',downloadURL)
            sessionStorage.setItem('p3',true)
            console.log("I3",downloadURL);

          })
        })

}
 
else{
  sessionStorage.setItem('p3',true)

}




             // IMAGE 4
if(image4!==props.location.state.branch.Images[3].url){
  console.log("IM 4>>>>>>>>>>>>");

    //1.
    let pictureRef = clientFirebase.storage().refFromURL(props.location.state.branch.Images[3].url);
   //2.
 pictureRef.delete().catch((e)=>console.log(e))
        //3.

        var ref3=clientFirebase.storage().ref(`/`).child(`hotel/${makeid(9)}`).put(i4File)
        setCurrentUpload4('4')
        ref3.on('state_changed', function(snapshot){
         // Observe state change events such as progress, pause, and resume
         // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
         var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress4(Math.floor(progress))
         console.log('IMAGE 4 Upload is ' + progress + '% done');
         if(progress==100){
           
        }
      }, function(error) {
        // document.getElementById('loadingSHOW').style.display='none'
        
        // Handle unsuccessful uploads
        console.log(error);
      }, function() {
        ref3.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          localStorage.setItem('Image4',downloadURL)
          sessionStorage.setItem('p4',true)
          console.log("I4",downloadURL);
          
          })
        })

}
else{
  sessionStorage.setItem('p4',true)

}





             // IMAGE 5
if(image5!==props.location.state.branch.Images[4].url){
  console.log("IM 5>>>>>>>>>>>>");

    //1.
    let pictureRef = clientFirebase.storage().refFromURL(props.location.state.branch.Images[4].url);
   //2.
 pictureRef.delete().catch((e)=>console.log(e))
   //3.
        var ref4=clientFirebase.storage().ref(`/`).child(`hotel/${makeid(9)}`).put(i5File)
        setCurrentUpload5('5')
        ref4.on('state_changed', function(snapshot){
         // Observe state change events such as progress, pause, and resume
         // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
         var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress5(Math.floor(progress))
         console.log('IMAGE 5 Upload is ' + progress + '% done');
         if(progress==100){
           
        }
      }, function(error) {
          // document.getElementById('loadingSHOW').style.display='none'
          
          // Handle unsuccessful uploads
          console.log(error);
        }, function() {
          ref4.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            localStorage.setItem('Image5',downloadURL)
            sessionStorage.setItem('p5',true)
            console.log("I5",downloadURL);
            


          })
        })

}

else{
  sessionStorage.setItem('p5',true)

}








             // IMAGE 6
if(image6!==props.location.state.branch.Images[5].url){
  console.log("IM 6>>>>>>>>>>>>");

    //1.
    let pictureRef = clientFirebase.storage().refFromURL(props.location.state.branch.Images[5].url);
   //2.
 pictureRef.delete().catch((e)=>console.log(e))
   //3.
        var ref5=clientFirebase.storage().ref(`/`).child(`hotel/${makeid(9)}`).put(i6File)
        setCurrentUpload6('6')
        ref5.on('state_changed', function(snapshot){
         // Observe state change events such as progress, pause, and resume
         // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
         var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress6(Math.floor(progress))
         console.log('IMAGE 6 Upload is ' + progress + '% done');
        
         if(progress==100){
           
        }
        
      }, function(error) {
        // document.getElementById('loadingSHOW').style.display='none'
        
        // Handle unsuccessful uploads
        console.log(error);
      }, function() {
        ref5.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          localStorage.setItem('Image6',downloadURL)
          sessionStorage.setItem('p6',true)
          console.log("I6",downloadURL);
        
          })
        })

}

else{
  sessionStorage.setItem('p6',true)

}



let myinterval=setInterval(() => {

  


if(sessionStorage.getItem('p1')=='true' 
&& sessionStorage.getItem('p2')=='true' 
&& sessionStorage.getItem('p3')=='true' 
&& sessionStorage.getItem('p4')=='true'
&& sessionStorage.getItem('p5')=='true'
&& sessionStorage.getItem('p6')=='true')
{
let obj={
  Images:[
    {
      url:localStorage.getItem('Image1')
    },
    {
     url:localStorage.getItem('Image2')
   },
   {
     url:localStorage.getItem('Image3')
   },
   {
     url:localStorage.getItem('Image4')
   },
   {
     url:localStorage.getItem('Image5')
   },
   {
     url:localStorage.getItem('Image6')
   }]
}
        clientFirebase.firestore().collection("All_Hotel").doc(props.location.state.branch.branch_uid).update(obj)


        document.getElementById('loadingSHOW').style.display='none'

        document.getElementById('verify').style.display='flex'
        setTimeout(() => {
          document.getElementById('verify').style.display='none'
          props.history.push('/admin/maps')
           
        }, 1600);

        clearInterval(myinterval)

}

}, 3000);


let obj={
  hotelName:name,
  email:email,
  phone:phone,
  name:Firstname +LastName,
  address:address,
  city:city,
  country:country,
  // zipCode:zip,
  details:Details,
  facilities:facilities,
  price:price1,
  }

  clientFirebase.firestore().collection("All_Hotel").doc(props.location.state.branch.branch_uid).update(obj)




            }


const [room_vali,setroom_vali]=useState()
const [person_vali,setperson_vali]=useState()
const [price_vali,setprice_vali]=useState()

const [room,setroom]=useState()
const [person,setperson]=useState()
const [price,setprice]=useState()

  // useEffect(()=>{
  // const {asd}=props.location.state;


// console.log("Csdcsdc",props.location.state.branch.branch_uid);
// clientFirebase.firestore().collection("All_Hotel").
// doc('JryhXh8awbXyatigApmtnZLEUvV2ttwyNOg1lOYxLtoGH2WjLJpZuFqy9N').update({
//   name:'878'})
// .then(() => {
//   console.log("Document successfully written!");
// })
// .catch((error) => {
//   console.error("Error writing document: ", error);
// });

// },[])
const add_room=()=>{
  document.getElementById('loadingSHOW').style.display='block'

  if (room) {
    setroom_vali()
  } else {
    setroom_vali('*Required')
    document.getElementById('loadingSHOW').style.display='none'

   }
   if (price) {
    setprice_vali()
  } else {
    setprice_vali('*Required')
    document.getElementById('loadingSHOW').style.display='none'

   }

   if (person) {
     setperson_vali()
  } else {
    setperson_vali('*Required')
    document.getElementById('loadingSHOW').style.display='none'


  }

  if (room && person && price) {






    clientFirebase.firestore().collection("All_Hotel").doc(props.location.state.branch.branch_uid).update({
      rooms: firebase.firestore.FieldValue.arrayUnion({price:price,roomAccomodation:person,roomNo:room,status:"free"})
    })
    .then(()=>{

  setperson('')
  setroom('')
  setprice('')
  document.getElementById('loadingSHOW').style.display='none'

  document.getElementById('verify').style.display='flex'
  setTimeout(() => {
    document.getElementById('verify').style.display='none'
  }, 1600);



    })
    .catch((e)=>{
      console.log("dscsd",e);
      document.getElementById('loadingSHOW').style.display='none'

    })


    
  }

}




 
let [editIt,setEditIT]=useState('')

var openFile = function(event,i) {
  var input = event.target;
  var reader = new FileReader();
  reader.onload = fileLoaded;
  reader.readAsDataURL(input.files[0]);




};

var fileLoaded = function (event) {
  var dataURL = event.target.result;
  // console.log(">>>>>>>>",editIt);
  // var output = document.getElementById(editIt);
  // output.src = dataURL;
  if(editIt==='image1'){
  setimage1(dataURL)
}
if(editIt==='image2'){
  setimage2(dataURL)
}
if(editIt==='image3'){
  setimage3(dataURL)
}
if(editIt==='image4'){
  setimage4(dataURL)
}
if(editIt==='image5'){
  setimage5(dataURL)
}
if(editIt==='image6'){
  setimage6(dataURL)
}
};



let RoomNoDelete=(v)=>{

 
console.log(v);

  clientFirebase.firestore().collection('All_Hotel').
  doc(props.location.state.branch.branch_uid).
  update({
    rooms: firebase.firestore.FieldValue.arrayRemove(v)
  })





// clientFirebase.firestore().collection("All_Hotel").doc(props.location.state.branch.branch_uid).update(obj)



}



let Delete=()=>{
  confirmAlert({
    title: 'Confirm to Delete',
    message: 'Are you sure to do this.',
    buttons: [
      {
        label: 'Yes',
        onClick: () => {
          clientFirebase.firestore().collection("All_Hotel").doc(props.location.state.branch.branch_uid).delete();  
          props.history.push('/admin/maps') 
        }
      },
      {
        label: 'No',
      }
    ]
  });
}

return (
    <>
      <div id="loadingSHOW" style={{display:'none'}}>
<div class="loading">Loading&#8230;</div>
<div className="progressDiv">
{currentUpload.length>0 || currentUpload2.length>0 ||currentUpload3.length>0 ||currentUpload4.length>0 ||currentUpload5.length>0 ||currentUpload6.length>0 ?
 <h3>
 Progress
</h3>
:
null}
 <br />
{currentUpload.length>0 ?
<p>
 Upload Image {currentUpload} : {progress}%
 </p>
 :
 null
}
<br />
{currentUpload2.length>0 ?
<p>
 Upload Image {currentUpload2} : {progress2}%
 </p>
 :
 null
}
<br />
{currentUpload3.length>0 ?
<p>
 Upload Image {currentUpload3} : {progress3}%
 </p>
 :
 null
}
<br />
{currentUpload4.length>0 ?
<p>
 Upload Image {currentUpload4} : {progress4}%
 </p>
 :
 null
}
<br />
{currentUpload5.length>0 ?
<p>
 Upload Image {currentUpload5} : {progress5}%
 </p>
 :
 null
}
<br />
{currentUpload6.length>0 ?
<p>
 Upload Image {currentUpload6} : {progress6}%
 </p>
 :
 null
}
</div>


</div>

<div id='verify'  style={{display:'none',justifyContent:'center',alignItems:'center',position:'fixed', backgroundColor:'rgb(76, 75, 75,0.95)',width:'100%',height:'120%',zIndex:'55',marginTop:-100}}>
  <div id='verify_hac' style={{display:'flex',justifyContent:'center',alignItems:'center',width:'100%',marginRight:'20%'}}>

  <img src={verify} className='verifyImg' ></img>
  </div>
</div>


     {
    props.hotel_data.length==0
    ?
    props.history.push('/admin/maps') 
    : 
    <div className="content">
        <Row >
          





          

        <Col md="11">
            <Card className="card-user">
              <CardHeader>
                <CardTitle tag="h5">Add Room</CardTitle>
              </CardHeader>
              <CardBody>
                <Form>
                  
                <Row>
                    <Col  md="4">
                      <FormGroup>
                        <label>Enter Room No</label>
                        <Input
                          // defaultValue={}
                          placeholder="5"
                          type="number"
                          value={room}
                          onChange={(e)=>{setroom(e.target.value)}}
                          />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-16}}>{room_vali}</p>
                    </Col>



                    <Col  md="4">
                      <FormGroup>
                        <label>Enter Price</label>
                        <Input
                          defaultValue=""
                          placeholder="100 (Don't put $)"
                          value={price}

                          type="number"
                          onChange={(e)=>setprice(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{price_vali}</p>

                    </Col>



                    <Col className="px-1" md="4">
                      <FormGroup>
                        <label style={{marginRight:'5%'}}>Room Accommodation</label><br></br>
                        <div style={{paddingTop:'0px',marginTop:'-10px'}} class="btn-group">
  <button style={{backgroundColor:'#8C8C8C'}} type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
  {person?person:'Select'} 
  </button>
  <div class="dropdown-menu dropdown-menu-right">
    <button class="dropdown-item" type="button"onClick={()=>setperson('1-2 Person')}>1-2 Person</button>
    <button class="dropdown-item" type="button"onClick={()=>setperson('2-4 Person')}>2-4 person</button>
    <button class="dropdown-item" type="button"onClick={()=>setperson('4-6 Person')}>4-6 Person</button>
  </div>
</div>
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-16}}>{person_vali}</p>
                    </Col>
                  </Row>
                  <Row>
                    <div className="update ml-auto mr-auto">
                      <Button
                        className="btn-round"
                        color="primary"
                        // type="submit"
                        onClick={()=>{add_room()}}
                        >
                        ADD Room
                      </Button>

                      
                    </div>
                  </Row>
                </Form>
              </CardBody>
      
            </Card>
          </Col>




          <Col md="11">
            <Card className="card-user">
              <CardHeader>
                <CardTitle tag="h5">All Rooms</CardTitle>
              </CardHeader>
              <CardBody>
                {console.log(props.location.state.branch.rooms)}
              <div id="centerME">
              <div className="boxStAc1">
             
             
                <table id='tableAll'>
                  <thead>
                    <tr>
                      <th scope="col">Sr No.</th>
                      <th scope="col"colSpan={2}  >Room
                       Accommodation</th>
                      <th scope="col" >Room No
                        </th>
                      <th scope="col">Status</th>
                      <th scope="col">Price</th>
                      
                      <th scope="col"></th>
        
                    </tr>
                  </thead>
         {
           rooms.map((v,i)=>{
             return(
                  <tbody key={i}>
                    <tr>
                      <td data-label="Sr No.">{i+1}</td>
                      <td data-label="Room Accomodation"colSpan={2} >{v.roomAccomodation}</td>
                      <td data-label="Room No">{v.roomNo}</td>
                      <td data-label="Status">{v.status}</td>
                      <td data-label="Price">{v.price} $</td>
                    
                     <td>
                       <Button onClick={()=>{RoomNoDelete(v)}} style={{backgroundColor:'red'}}>
                         Delete
                       </Button>
                     </td>
                    </tr>
                  
                  </tbody>
                )
              })
            }
                </table>
              </div>
            </div>
              </CardBody>
      
            </Card>
          </Col>





          <Col  md="11">
            <Card  className="card-user">
              <CardHeader>
                <CardTitle tag="h5">Branch Details</CardTitle>
              </CardHeader>
              <CardBody>
              <Form>
                  <Row>
                    <Col className="pr-1" md="5">
                      <FormGroup>
                        <label>Hotel Branch Name</label>
                        <Input
                          defaultValue={name}
                        onChange={(e)=>setName(e.target.value)}  
                          placeholder="london Branch etc"
                          type="text"
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{nameValidation}</p>
                    </Col>
                    <Col className="px-1" md="3">
                      <FormGroup>
                        <label>Phone Number</label>
                        <Input
                          defaultValue={phone}
                          placeholder="+923223760042"
                          onChange={(e)=>setPhone(e.target.value)}  

                          type="Number"
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{phoneValidation}</p>

                    </Col>
                    <Col className="pl-1" md="4">
                      <FormGroup>
                        <label htmlFor="exampleInputEmail1">
                          Email address
                        </label>
                        <Input
                        defaultValue={email}
                        placeholder="Email"                
                         onChange={(e)=>setEmail(e.target.value)} 
                         type="email" />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{emailValidation}</p>

                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="6">
                      <FormGroup>
                        <label> Full Name(Branch Manager)</label>
                        <Input
                          defaultValue={Firstname}
                          placeholder="Awais"
                          type="text"
                          onChange={(e)=>setFirstName(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{FirstnameValidation}</p>

                    </Col>
                   
                  </Row>
                  <Row>
                    



                    <Col  md="4">
                      <FormGroup>
                        <label>Enter Price</label>
                        <Input
                          defaultValue={price1}
                          placeholder="100 (Don't put $)"
                          type="number"
                          onChange={(e)=>setPrice1(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{priceValidation}</p>

                    </Col>


                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <label>Branch Address</label>
                        <Input
                          defaultValue={props.location.state.branch.address}
                          placeholder="Melbourne, Australia"
                          type="text"
                          onChange={(e)=>setAddress(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{addressValidation}</p>

                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="4">
                      <FormGroup>
                        <label>City</label>
                        <Input
                          defaultValue={props.location.state.branch.city}
                          placeholder="City"
                          type="text"
                          onChange={(e)=>setCity(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{cityValidation}</p>

                    </Col>
                    <Col className="px-1" md="4">
                      <FormGroup>
                        <label>Country</label>
                        <Input
                          defaultValue={props.location.state.branch.country}
                          placeholder="Country"
                          type="text"
                          onChange={(e)=>setCountry(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{countryValidation}</p>

                    </Col>
                    <Col className="pl-1" md="4">
                      <FormGroup>
                        <label>Postal Code</label>
                        <Input
                        defaultValue={props.location.state.branch.zipCode}
                        placeholder="ZIP Code"
                        onChange={(e)=>setZip(e.target.value)}
                        type="number" />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{zipValidation}</p>

                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <label>Detail</label>
                        <Input
                        defaultValue={props.location.state.branch.details}
                          type="textarea"
                          onChange={(e)=>setDetails(e.target.value)}
                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{DetailsValidation}</p>

                    </Col>
                    <Col md="12">
                      <FormGroup>
                        <label>Facilities</label>
                        <Input
                          type="textarea"
                          defaultValue={props.location.state.branch.facilities}
                          onChange={(e)=>setFacilities(e.target.value)}

                        />
                      </FormGroup>
                      <p style={{color:'red',fontSize:11,height:12,marginTop:-10}}>{facilitiesValidation}</p>

                    </Col>

                    <Col md="12">
                      <FormGroup>
                        <label>Select Images</label>
                       
                      </FormGroup>
                    </Col>


                    <div className="mainFlex">

   <div className="imageDic">
  <img id="image1" style={{width:'100%',height:180,border:'none'}} alt="Image1" src={image1}></img>
   <span class="btn btn-primary btn-file"   onClick={()=>{setEditIT('image1')}} style={{backgroundColor:'#C6333F',width:'100%',margin:0}}>
   Update...<input onChange={(event)=>{openFile(event); seti1File(event.target.files[0]) }} type="file" />
  </span>               
   </div>


{/* {console.log(image2)} */}
                   <div className="imageDic">
  <img id="image2" style={{width:'100%',height:180,border:'none',backgroundColor:(image2.length==0)? 'rgba(244, 244, 244,0)' : '#fff'}} alt="Image2" src={image2}></img>
   <span class="btn btn-primary btn-file"   onClick={()=>{setEditIT('image2')}} style={{backgroundColor:'#C6333F',width:'100%',margin:0}}>
   Update...<input onChange={(event)=>{openFile(event); seti2File(event.target.files[0]) }} type="file" />
  </span>               
   </div>



<div className="imageDic">
  <img id="image3" style={{width:'100%',height:180,border:'none'}} alt="Image3" src={image3}></img>
   <span class="btn btn-primary btn-file"   onClick={()=>{ setEditIT('image3')}} style={{backgroundColor:'#C6333F',width:'100%',margin:0}}>
   Update...<input onChange={(event)=>{openFile(event); seti3File(event.target.files[0]) }} type="file" />
  </span>               
   </div>




<div className="imageDic">
  <img id="image4" style={{width:'100%',height:180,border:'none'}} alt="Image4" src={image4}></img>
   <span class="btn btn-primary btn-file"   onClick={()=>{ setEditIT('image4')}} style={{backgroundColor:'#C6333F',width:'100%',margin:0}}>
   Update...<input onChange={(event)=>{openFile(event); seti4File(event.target.files[0]) }} type="file" />
  </span>               
   </div>



<div className="imageDic">
  <img id="image5" style={{width:'100%',height:180,border:'none'}} alt="Image5" src={image5}></img>
   <span class="btn btn-primary btn-file"   onClick={()=>{ setEditIT('image5')}} style={{backgroundColor:'#C6333F',width:'100%',margin:0}}>
   Update...<input onChange={(event)=>{openFile(event); seti5File(event.target.files[0])}} type="file" />
  </span>               
   </div>



  <div className="imageDic">
  <img id="image6" style={{width:'100%',height:180,border:'none'}} alt="Image6" src={image6}></img>
   <span class="btn btn-primary btn-file"   onClick={()=>{ setEditIT('image6')}} style={{backgroundColor:'#C6333F',width:'100%',margin:0}}>
   Update...<input onChange={(event)=>{openFile(event); seti6File(event.target.files[0])}} type="file" />
  </span>               
   </div>

                    </div>
      


                  </Row>
          
                  <Row style={{marginTop:'4%'}}>
                    <div className="update ml-auto mr-auto">
                      <Button
                        className="btn-round"
                        color="primary"
                        // type="submit"
                        onClick={()=>UpdataBranch()}
                      >
                       Update Branch
                      </Button>
                    </div>
                  </Row>
                </Form>
              </CardBody>
            <button  onClick={()=>{ Delete()}}  type="button" style={{backgroundColor:'#C6333F',marginTop:'8%'}} class="btn btn-primary">Delete Branch</button>
            </Card>
          </Col>
      




















        </Row>
      </div>
      }
    </>
    );
  }
  
  
  const mapStateToProps = (state) => {
    return {
      hotel_data:state.hotel_data,
    }
  }
  
  
  const mapDispatchToProps = dispatch => {
    return {
      // dispatching plain actions
      // get_data: () => dispatch(get_data())  
      
    }}
    export default connect(mapStateToProps,mapDispatchToProps)(Edit)